<template>
  <div class="p-4">

    <div class="font-bold pb-4">
      Select all certificates you would like to include in your transcript.
    </div>
    
    <!-- Desktop Table -->
    <div>
      <div class="scrollable-area">
        <table class="min-w-full bg-white border border-gray-300">
          <thead>
          <tr>
            <th class="px-4 py-2 border-b">
              <input type="checkbox" @change="toggleAll" :checked="allSelected" />
            </th>
            <th class="px-4 py-2 border-b">Activity Name</th>
            <th class="px-4 py-2 border-b">Completed Date</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(certificate, index) in earnedCertificates"
              :key="index"
              class="border-b"
          >
            <td class="px-4 py-2 text-center">
              <input
                  type="checkbox"
                  v-model="selectedCertificates"
                  :value="certificate"
              />
            </td>
            <td class="px-4 py-2">{{ certificate.completedActivityName }}</td>
            <td class="px-4 py-2">{{ certificate.completedDate }}</td>
          </tr>
          </tbody>
        </table>
      </div>


      <!-- Mobile Layout -->
      <div v-for="(certificate, index) in sortedCertificates" :key="index" class="md:hidden border-b border-gray-300 p-4">
        <div class="flex items-center mb-2">
          <input
              type="checkbox"
              v-model="selectedCertificates"
              :value="certificate"
              class="mr-3"
          />
          <span class="font-semibold">{{ certificate.completedActivityName }}</span>
        </div>
        <div class="text-gray mb-2">
          <span class="block font-medium">Completed Date:</span>
          <span>{{ certificate.completedDate }}</span>
        </div>
      </div>
    </div>

    <!-- Download Button -->
    <d-btn outline class="lg mt-4 border-primary text-primary" size="sm" @click="downloadTranscript">
      Download Transcript
    </d-btn>
  </div>
</template>

<script>
export default {
  props: {
    earnedCertificates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedCertificates: [],
    };
  },
  computed: {
    allSelected() {
      return (
          this.selectedCertificates.length === this.earnedCertificates.length &&
          this.earnedCertificates.length > 0
      );
    },
    sortedCertificates() {
      return this.earnedCertificates.sort((a, b) => {
        return  new Date(a.completedDate) - new Date(b.completedDate);
      });
    },
  },
  mounted() {
    console.log(this.sortedCertificates)
  },
  methods: {
    toggleAll(event) {
      this.selectedCertificates = event.target.checked
          ? [...this.earnedCertificates]
          : [];
    },
    downloadTranscript() {
      
      if (this.selectedCertificates.length === 0) {
        this.$toast.error('Please select at least one certificate to include in your transcript.');
        return;
      }
      
      const selectedCertificateIds = this.selectedCertificates.map((certificate) => certificate.id);
      const payload = {
        ids: selectedCertificateIds,
      }
      
      fetch('/api/transcript', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Server returned ${response.status}: ${response.statusText}`);
            }
            return response.blob(); // Handle as binary data
          })
          .then((blob) => {
            // Create a Blob URL and trigger the download
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'transcript.pdf'; // Set the file name
            document.body.appendChild(link); // Append to the DOM
            link.click(); // Trigger the download
            document.body.removeChild(link); // Clean up

            // Revoke the URL release memory
            setTimeout(() => URL.revokeObjectURL(url), 100);
          })
          .catch((error) => {
            console.error('Error downloading transcript:', error);
            this.$toast.error('An error occurred while generating your transcript. Please try again or contact support if the problem persists.');
          });
    },
  },
};
</script>

<style scoped>
  .scrollable-area {
    max-height: 600px;
    overflow-y: auto;
  }
</style>